module.exports = __webpack_public_path__ + "img/Ultragannefinal.2509ff1b.png";